import React, { Component } from 'react'
import { formatDate } from '../../helpers.js'

class Post extends Component {
  renderBodyText = (post) => {
    return {__html: post.bodytext}
  }

  render() {
    return (
      <article className="pa4 mb2 bg-white card">
        <div className="pathway flex flex-row justify-between items-end bb2">
          <div className="f3 f2-ns">
            {this.props.post.headline}
          </div>
          <div className="f4 noshrink ml2">
						{formatDate(this.props.post.timestamp)}
          </div>
        </div>
        <hr className="w-100 mt1 mb3"/>
        <div className="bod droid f5 lh-copy">
          <div dangerouslySetInnerHTML={this.renderBodyText(this.props.post)} />
        </div>
      </article>
    )
  }
}

export default Post


// WEBPACK FOOTER //
// ./src/components/multi/Post.js